<template lang="pug">
#processSetting
  set(ref="set" v-show="showPage==='set'" @openDesigner="openDesigner")
  flowEditor(ref="flowEditor" v-if="showPage==='designer'" :viewMode="viewMode" @closeDesigner="close")
</template>

<script>
import set from "@/CommonDP/components/processComponents/components/set.vue";
import flowEditor from "@/CommonDP/components/processComponents/components/flowEditor.vue";

export default {
  name: "ProcessDefinition",
  components: { set, flowEditor },
  data () {
    return {
      viewMode: 0, // 新增0 编辑1 查看2
      showPage: 'set' // 展示哪个页面
    };
  },
  methods: {
    openDesigner(val) {
      this.viewMode = val || 0;
      this.showPage = "designer";
    },
    async close(boolean) {
      this.showPage = "set";
      await this.$nextTick();
      boolean && this.$refs.set.updateNodes();
    }
  }
};
</script>

<style lang="scss" scoped>
#processSetting{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
